import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';
import { MORTGAGE_PROMO_TYPES } from '../../../constants/promos';

export const getAuthorDescription = (promo: IPromoInfo, hasContacts: boolean): string | null => {
  if (promo.promoType === EPromoType.CianMortgage) {
    return null;
  }

  if (!hasContacts) {
    return null;
  }

  const isMortgage = MORTGAGE_PROMO_TYPES.includes(promo.promoType);
  const promoLabel = isMortgage ? 'ипотечном' : 'акционном';
  const agentLabel = promo.isFromBuilder ? 'застройщика' : 'представителя застройщика';

  return `Узнайте у ${agentLabel} подробности об ${promoLabel} предложении`;
};
